import { createSelector, createSlice } from '@reduxjs/toolkit';

export interface DashboardWidgetStateModel {
  id: string;
  width: number;
  height: number;
  x: number;
  y: number;
}
export const DASHBOARD_WIDGETS_FEATURE_KEY = 'dashboardWidgets';

export interface DashboardWidgetsState {
  activeWidgets: DashboardWidgetStateModel[];
}

const initialDashboardWidgetsState: DashboardWidgetsState = {
  activeWidgets: [
    {
      id: 'my_upcoming_events',
      x: 0,
      y: 0,
      width: 4,
      height: 2,
    }
  ]
};

export const _dashboardWidgetsSlice = createSlice({
  name: DASHBOARD_WIDGETS_FEATURE_KEY,
  initialState: initialDashboardWidgetsState,
  reducers: {
    add: (state, action) => {
      const widgetToAdd: DashboardWidgetStateModel = {
        id: action.payload.id,
        height: action.payload.minHeight,
        width: action.payload.minWidth,
        x: 0,
        y: state.activeWidgets.length,
      };
      state.activeWidgets.push(widgetToAdd);
    },
    update: (state, action) => {
      const index = state.activeWidgets.findIndex(
        (widget) => widget.id === action.payload.id
      );
      if (index >= 0) {
        state.activeWidgets[index] = action.payload;
      }
    },
    updateAll: (state, action) => {
      action.payload.forEach((item: any) => {
        const index = state.activeWidgets.findIndex(
          (widget) => widget.id === item.id
        );
        if (index >= 0) {
          state.activeWidgets[index] = item;
        }
      });
    },
    remove: (state, action) => {
      state.activeWidgets = state.activeWidgets.filter(
        (widget) => widget.id !== action.payload.id
      );
    },
  },
});

/*
 * Export reducer for store configuration.
 */
export const dashboardWidgetsReducer = _dashboardWidgetsSlice.reducer;
export const dashboardWidgetsActions = _dashboardWidgetsSlice.actions;

const getDashboardWidgetsState = (rootState: any): DashboardWidgetsState =>
  rootState[DASHBOARD_WIDGETS_FEATURE_KEY];

export const dashboardWidgetsState = createSelector(
  getDashboardWidgetsState,
  (state) => state
);
